/* global ViewController, WebView */
var safeShareController = new ViewController({
    directory : "views/public",
    name: "safeShare",
    container: "main",
    route: "safe-share"
}) ;

safeShareController.prepareDataOnEnter = function(token, callback){
    var path = "";
    var indexSlash = token.indexOf("/") ;
    if(indexSlash!==-1){
        path = token.substring(indexSlash) ;
        token = token.substring(0, indexSlash) ;
    }
    var data = {
        token: token,
        path: path
    } ;
    this.api.public.getSafeShareSettings(function(err, settings){
        if(err) {return callback(err) ;}
        this.api.public.getSafeShareDocuments(token, path, function(err, result){
            if(err){
                if(err === "EXPIRED"){
                    return callback(null, { expired: true }) ;
                }
                if(err === "NOT_FOUND"){
                    return callback(null, { notfound: true }) ;
                }
                if(err === "NEED_PASSWORD"){
                    var viewChange = new WebView("views/public", "docSharePasswordPopup") ;
                    viewChange.openInPopup({
                        title: '',
                        aboveAll: true
                    })  ;
                    viewChange.on("validate",function(){
                        var passData = viewChange.getData() ;
                        
                        viewChange.close() ;
                        this.api.public.getSafeShareDocuments(token, path, passData.share_password, function(err, result){
                            if(err){
                                if(err === "EXPIRED"){
                                    return callback(null, { expired: true }) ;
                                }
                                if(err === "WRONG_PASSWORD"){
                                    return callback(null, { wrongpassword: true }) ;
                                }
                                return callback(err) ;
                            }
                            data.result = result ;
                            result.folders.forEach(function(folder){
                                folder.name = folder.path.substring(folder.path.lastIndexOf("/")+1) ;
                            });
                            data.password = passData.share_password ;
                            if(settings.attach){
                                data.hasCustomBg = true ;
                            }
                            callback(null, data) ;
                        }.bind(this)) ;
                    }.bind(this)) ;
                    return;
                }
                return callback(err) ;
            }
            data.result = result ;
            result.folders.forEach(function(folder){
                folder.name = folder.path.substring(folder.path.lastIndexOf("/")+1) ;
            });
            if(settings.attach){
                data.hasCustomBg = true ;
            }
            callback(null, data) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

safeShareController.onFolder = function(ev){
    var folder = ev.data.data ;
    this.updateRouteData(this.viewOptions.route, this.data.token+"/"+folder.path) ;
} ;

safeShareController.onDownload = function(ev){
    this.view.longTask(function(done){
        this.api.public.downloadSafeSharedDocument(this.data.token,
            ev.data.data.id,
            this.data.password
        , done) ;
    }.bind(this)) ;
} ;


module.exports = safeShareController ;